import React, { useCallback } from 'react'
import { I18n, hooks } from '@front/volcanion'
import { UserUtils } from '@front/volcanion/utils'
import { MenuSelectorField, ModelAutocompleteField, ModelMenuSelectorField, TextField } from '@front/squirtle'
import { Grid, Box } from '@mui/material'
import _ from 'lodash'

const BillingSection = ({ mode }) => {
  const billing_status_list = hooks.useBillingStatusList()

  const billingStatusOptions = _.map(billing_status_list, (status) => ({
    label: I18n.t(`billing.status.${status}`),
    value: status
  }))

  const autocompleteMutatorOperator = useCallback(q => ({
    auth: { username: { startsWith: q } }
  }), [])

  return (
    <Box flex={1}>
      <Grid container spacing={1} mb={1}>
        <Grid hidden={mode !== 'billing'} size={2}>
          <TextField name={'order_client_id'} label={I18n.t('order.id.alter')} />
        </Grid>
        <Grid size="grow">
          <ModelMenuSelectorField
            name={'payment_type'}
            label={I18n.t('bank.payment_mode')}
            model_name={'paymenttype'}
            searchMode={'search'}
            config={{
              initial_filter: {},
              sort: ['display_index ASC']
            }}
            labelKeys={['name_translated']}
            multiple
          />
        </Grid>
        <Grid size="grow">
          <MenuSelectorField
            name='billing_status'
            label={I18n.t('billing.status.label', { count: 1 })}
            options={billingStatusOptions}
            multiple
          />
        </Grid>
        <Grid hidden={mode !== 'billing'} size="grow">
          <ModelMenuSelectorField
            name={'assigned_transport.license.billing_category'}
            label={I18n.t('contract.category')}
            model_name={'billingcategory'}
            searchMode={'search'}
            labelKeys={['name_translated']}
            config={{ initial_filter: {} }}
            multiple
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid size="grow">
          <TextField name='customer_ref' label={I18n.t('bank.b2c.customer_ref')} />
        </Grid>
        <Grid size="grow">
          <TextField name='order_doc' label={I18n.t('document.b2c.id')} />
        </Grid>
        <Grid hidden={mode !== 'order'} size="grow">
          <ModelAutocompleteField
            name='operator'
            label={I18n.t('operator', { count: 1 })}
            model_name='user'
            searchMode='search'
            searchQuery='startsWith'
            autocompleteMutator={autocompleteMutatorOperator}
            config={{
              forced_filter: { staffinfo: { '!': null } },
              mutator: user => ({
                label: UserUtils.getFormatedName(user?.info, { prefix: user?.auth?.username }),
                ...user
              }),
              populate: ['auth', 'info']
            }}
            loadOnFocus={false}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(BillingSection)
